module.exports = __webpack_public_path__ + "img/shuang3.9ee87467.png";